// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1312":"f41f80e9","2483":"44ceb648","6472":"6affbda0","7711":"c0895552","8914":"5cbdff31"}[chunkId] + ".css";
};